import Link from "next/link";
import { genericEventHandler } from "@/analytics/events";
import { GlobalEvents } from "@/analytics/events/constants";
import { ForgotPasswordForm } from "@/components/app/authForms/forgot-password";
import {
  StyledAuthPageContent,
  StyledAuthPageLayout,
} from "@/components/app/authForms/layout/styles";
import Layout from "@/components/app/layout";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import { StyledHr } from "@/components/uielements/hr";
import { ROUTES } from "@/constants/routes";
import { useWebConfig } from "@/redux/cmsConfig";
import { safelyGetConfig } from "@/utils/stringHelpers";

export default function ForgotPassword() {
  const webConfig = useWebConfig();

  return (
    <Layout
      backgroundOverride={true}
      disabled={safelyGetConfig(webConfig, "accounts.disable_accounts")}
    >
      <StyledAuthPageLayout>
        <StyledAuthPageContent>
          <StringAccessor
            tag="h1"
            accessor="forgot_password.header"
            html={true}
          />
          <StringAccessor
            tag="h3"
            accessor="forgot_password.subheader"
            html={true}
          />
          <StyledHr background="transparent" />
          <ForgotPasswordForm />
          <StyledHr />
          <p>
            <StringAccessor accessor="signup.prompt" html={true} />
            &nbsp;
            <Link href={ROUTES.SIGN_UP} passHref={true}>
              <a
                onClick={() =>
                  genericEventHandler(GlobalEvents.AUTH__CLICK_SIGN_UP)
                }
              >
                <StringAccessor accessor="signup.cta" />
              </a>
            </Link>
          </p>
        </StyledAuthPageContent>
      </StyledAuthPageLayout>
    </Layout>
  );
}
